/**
  * Definiert Verhalten und Darstellung einer Seite
  * @namespace v3sWbtPlayerApp:page
  */

/**
 *
 * Startet Seitenablauf nachdem alle Seiten-Elemente geladen und kompiliert sind
 * @class controller_v3sPageCtrl
 * @memberOf v3sWbtPlayerApp:page
 */
angular.module('v3sWbtPlayerApp').controller('v3sPageCtrl', ["$scope", "wbt", "sco", "page", "v3sPageService", function ($scope, wbt, sco, page, v3sPageService) {
    $scope.currentPage = page;
    $scope.hideContent = false;

    $scope.sco = sco;
    $scope.wbt = wbt;
    
    $scope.testSco = wbt.getTestSco();
    $scope.test = null;
    if (!!$scope.testSco) {
        $scope.test = $scope.testSco.getTest();
    }

    v3sPageService.init($scope);

    $scope.getVar = v3sPageService.getValue;
    $scope.addElement = v3sPageService.addElement;

    $scope.$on('$destroy', function () {
        v3sPageService.destroy();
    });
}]);
